import { graphql } from 'gatsby';

export const ChromaticPricingSliceFragment = graphql`
    fragment PrismicChromaticPricingFragment on PRISMIC_PageBodyChromatic_pricing {
        type
        primary {
            chromatic_pricing_title
        }
    }
`;
